import { useState } from 'react';
import { LuFlaskConical } from 'react-icons/lu';
import API from '../../api/axios';
import { Button } from '../../components/ui';
import { fmtF } from '../../theme';
import '../../components/abonnement/Abonnement.css';

/**
 * Guichet de paiement simulé (PAIEMENT_SIMULATION=true) : remplace CinetPay
 * pendant les tests. Aucun argent n'est débité.
 */
export default function SimulationPaiement() {
  const params = new URLSearchParams(window.location.search);
  const transactionId = params.get('transaction_id');
  const montant = Number(params.get('montant')) || 0;
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState('');

  const simuler = async succes => {
    setEnvoi(true);
    try {
      await API.post(`/paiements/simulation/${encodeURIComponent(transactionId)}`, { succes });
      window.location.href = `/paiement/retour?transaction_id=${encodeURIComponent(transactionId)}`;
    } catch (e) {
      setErreur(e?.response?.data?.message?.replace(/^❌\s*/, '') || 'Erreur');
      setEnvoi(false);
    }
  };

  return (
    <main className="ab-page-centre" style={{ '--accent': '#EA580C' }}>
      <div className="ab-carte-centre">
        <div className="ab-icone-statut is-attente"><LuFlaskConical aria-hidden /></div>
        <h1>Paiement de test</h1>
        <p>Ce guichet remplace CinetPay en mode test. Aucun argent n'est débité.</p>
        <p style={{ fontSize: 28, fontWeight: 800, color: '#0F172A' }} className="ab-num">{fmtF(montant)}</p>
        <p className="ab-sub">Référence {transactionId}</p>
        {erreur && <p style={{ color: '#B91C1C' }}>{erreur}</p>}
        <div className="ab-actions" style={{ justifyContent: 'center', marginTop: 8 }}>
          <Button onClick={() => simuler(true)} disabled={envoi || !transactionId}>Simuler un paiement réussi</Button>
          <Button variant="danger" onClick={() => simuler(false)} disabled={envoi || !transactionId}>Simuler un refus</Button>
        </div>
      </div>
    </main>
  );
}
